import { useEffect, useMemo, useRef, useState } from "react";
import InputSearch from "../../../components/inputs/inputSearch/inputSearch";
import Table from "../../../components/table/table";
import Button from "../../../components/button/button";
import Modal from "../../../components/modal/modal";
import Input from "../../../components/inputs/input/input";
import Notification from "../../../components/notification/notification";
import { IoAdd } from "react-icons/io5";
import { MdEdit } from "react-icons/md"; // ✅ Añadir icono de editar
import { getApiInstance } from "../../../utils/api";
import InputDropdown from "../../../components/inputs/inputDropdown/inputDropdown";
import Popup from "../../../components/popup/popup";
import { BsDoorClosed } from "react-icons/bs";

export default function TiendasProveedor({ user }) {
  const [searchTerm, setSearchTerm] = useState("");
  const [tiendas, setTiendas] = useState([]);

  // Estados para modal de crear
  const [isNewModalOpen, setIsNewModalOpen] = useState(false);
  const [nuevoCodigo, setNuevoCodigo] = useState("");
  const [nuevaCadena, setNuevaCadena] = useState("");
  const [nuevoPais, setNuevoPais] = useState("");
  const [nuevaCiudad, setNuevaCiudad] = useState("");
  const [nuevaDireccion, setNuevaDireccion] = useState("");
  const [nuevaFechaCierre, setNuevaFechaCierre] = useState("");
  const [proveedores, setProveedores] = useState([]);
  const [selectedProveedor, setSelectedProveedor] = useState(null);
  const [isCreating, setIsCreating] = useState(false);

  // ✅ Estados para modal de editar
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [tiendaEditando, setTiendaEditando] = useState(null);
  const [editCodigo, setEditCodigo] = useState("");
  const [editCadena, setEditCadena] = useState("");
  const [editPais, setEditPais] = useState("");
  const [editCiudad, setEditCiudad] = useState("");
  const [editDireccion, setEditDireccion] = useState("");
  const [editFechaCierre, setEditFechaCierre] = useState("");
  const [isUpdating, setIsUpdating] = useState(false);

  const [isPopupCloseOpen, setIsPopupCloseOpen] = useState(false);

  const notificationRef = useRef();
  const api = getApiInstance();
  const [selectedTiendas, setSelectedTiendas] = useState([]);

  const fetchProveedores = async () => {
    try {
      console.log("Fetching proveedores...");
      const res = await api.get("/api/Empresa/GetAllEmpresas");
      console.log("Proveedores response:", res);
      if (res && res.status === 200 && Array.isArray(res.data)) {
        setProveedores(res.data.filter((x) => x.codTipoEmpresa === 3)); // solo proveedores
      } else if (res && res.status === 404) {
        setProveedores([]);
      }
    } catch (err) {
      console.error("Error obteniendo proveedores:", err);
      setProveedores([]);
    }
  };

  const fetchTiendasFromApi = async () => {
    try {
      const res = await api.get("/api/Presupuestos/tiendas");
      if (res && res.status === 200 && Array.isArray(res.data)) {
        setTiendas(res.data);
      } else if (res && res.status === 404) {
        setTiendas([]);
      }
    } catch (err) {
      console.error("Error obteniendo tiendas del proveedor:", err);
      setTiendas([]);
    }
  };

  // cargar tiendas al montar y cuando cambie el user (por seguridad)
  useEffect(() => {
    fetchTiendasFromApi();
    fetchProveedores();
  }, [user]);

  const formatDate = (value) => {
    if (!value) return "";
    const d = new Date(value);
    if (isNaN(d.getTime())) return value; // si no es fecha válida, devolver raw
    return d.toLocaleDateString();
  };

  // ✅ Función para formatear fecha para input date
  const formatDateForInput = (value) => {
    if (!value) return "";
    const d = new Date(value);
    if (isNaN(d.getTime())) return "";
    return d.toISOString().split("T")[0]; // formato YYYY-MM-DD
  };

  // ✅ Acciones para cada fila
  const actions = (row) => [
    {
      label: "Editar",
      icon: <MdEdit />,
      onClick: () => handleEditTienda(row),
    },
  ];

  const columns = [
    {
      key: "codigo",
      label: "Código",
      render: (row) => row.codigo ?? "-",
    },
    {
      key: "cadena",
      label: "Cadena",
      render: (row) => row.cadena ?? "-",
    },
    {
      key: "proveedor",
      label: "Proveedor",
      render: (row) => row.nombreProveedor ?? "-",
    },
    {
      key: "pais",
      label: "País",
      render: (row) => row.pais ?? "-",
    },
    {
      key: "ciudad",
      label: "Ciudad",
      render: (row) => row.ciudad ?? "-",
    },
    {
      key: "fechaAlta",
      label: "Fecha alta",
      render: (row) => formatDate(row.fechaAlta ?? null),
    },
    {
      key: "fechaCierre",
      label: "Fecha cierre",
      render: (row) => formatDate(row.fechaCierre ?? null),
    },
  ];

  const filtered = useMemo(() => {
    if (!searchTerm)
      return tiendas.map((t) => ({ ...t, codMueble: t.codTienda }));
    const term = searchTerm.toLowerCase();
    return tiendas
      .filter((t) =>
        Object.values(t || {})
          .map((v) => (v === null || v === undefined ? "" : String(v)))
          .join(" ")
          .toLowerCase()
          .includes(term)
      )
      .map((t) => ({ ...t, codMueble: t.codTienda }));
  }, [searchTerm, tiendas]);

  const openNewModal = () => {
    setNuevoCodigo("");
    setNuevaCadena("");
    setNuevoPais("");
    setNuevaCiudad("");
    setNuevaDireccion("");
    setNuevaFechaCierre("");
    setIsNewModalOpen(true);
  };

  const openCloseModal = () => {
    setIsPopupCloseOpen(true);
  };

  const handleConfirmClose = async () => {
    const idsCierre = tiendas
      .filter(
        (x) => selectedTiendas.includes(x.codTienda) && !x.fechaCierre
      )
      .map((t) => t.codTienda);

    if (!idsCierre.length) {
      notificationRef.current?.addNotification(
        "No hay tiendas abiertas seleccionadas.",
        "warning"
      );
      setIsPopupCloseOpen(false);
      return;
    }

    try {
      // POST: envia lista simple de ints
      const response = await api.post(
        "/api/Presupuestos/CerrarTiendas",
        idsCierre,
        {
          headers: { "Content-Type": "application/json" },
        }
      );

      const data = response?.data ?? {};

      // Fecha devuelta por el backend (string ISO normalmente). Si no llega, usa ahora.
      const fechaCierreStr = data?.fechaCierre ?? null;
      const fechaCierre = fechaCierreStr
        ? new Date(fechaCierreStr)
        : new Date();

      // IDs actualizados: prioriza `actualizadas` (lista), si no, `codTiendas`, si no, usa los enviados (optimista).
      const updatedIds =
        Array.isArray(data?.actualizadas) && data.actualizadas.length
          ? data.actualizadas
          : Array.isArray(data?.codTiendas) && data.codTiendas.length
          ? data.codTiendas
          : idsCierre;

      // Actualiza el estado de tiendas: añade/actualiza la fecha para los IDs actualizados.
      setTiendas((prev) =>
        prev.map((t) => {
          if (updatedIds.includes(t.codTienda)) {
            return {
              ...t,
              // guarda tal cual la cadena devuelta o, si no, en ISO (para consistencia)
              fechaCierre: fechaCierreStr ?? fechaCierre.toISOString(),
            };
          }
          return t;
        })
      );

      // (Opcional) Limpiar la selección de las que se acaban de cerrar
      setSelectedTiendas((prev) =>
        prev.filter((t) => !updatedIds.includes(t.codTienda))
      );

      // Notificación de éxito, formateada a español (solo para mostrar; en estado guardamos ISO)
      const cuando = fechaCierre.toLocaleString("es-ES", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      });

      notificationRef.current?.addNotification(
        `Se cerraron ${updatedIds.length} tienda(s) el ${cuando}.`,
        "success"
      );
    } catch (error) {
      console.error("Error cerrando tienda:", error);

      // Extrae mensaje amigable si lo manda el backend
      const message =
        error?.response?.data?.message ||
        error?.response?.data ||
        "Error cerrando la tienda. Comprueba la consola.";

      notificationRef.current?.addNotification(String(message), "error");
    } finally {
      setIsPopupCloseOpen(false);
    }
    setIsPopupCloseOpen(false);
  };
  const handleCancelClose = () => {
    setIsPopupCloseOpen(false);
  };

  // ✅ Función para cerrar modal de creación

  const closeNewModal = () => {
    setIsNewModalOpen(false);
  };

  const handleCreateTienda = async () => {
    if (!nuevoCodigo || !nuevaCadena || !nuevoPais || !nuevaCiudad) {
      notificationRef.current?.addNotification(
        "Rellena los campos obligatorios: Código, Cadena, País, Ciudad.",
        "warning"
      );
      return;
    }

    // Validación de código duplicado en el frontend
    const codigoExistente = tiendas.find(
      (t) => t.codigo?.toLowerCase() === nuevoCodigo.toLowerCase()
    );
    if (codigoExistente) {
      notificationRef.current?.addNotification(
        `Ya existe una tienda con el código "${nuevoCodigo}". Por favor, utiliza un código diferente.`,
        "error"
      );
      return;
    }

    const payload = {
      Codigo: nuevoCodigo,
      Cadena: nuevaCadena,
      Pais: nuevoPais,
      Ciudad: nuevaCiudad,
      Direccion: nuevaDireccion || null,
      FechaCierre: nuevaFechaCierre || null,
      CodEmpresa: selectedProveedor ? selectedProveedor.codEmpresa : 0,
    };

    try {
      setIsCreating(true);
      const response = await api.post("/api/Presupuestos/tiendas", payload);

      if (response.status === 200 && response.data) {
        const existe = response.data.existente ?? false;

        if (existe) {
          // Si la tienda ya existe, no cerramos el modal y mostramos error
          notificationRef.current?.addNotification(
            `Ya existe una tienda con el código "${nuevoCodigo}". Por favor, utiliza un código diferente.`,
            "error"
          );
        } else {
          // Solo si es una nueva tienda, recargamos y cerramos el modal
          await fetchTiendasFromApi();
          notificationRef.current?.addNotification(
            "Tienda creada correctamente.",
            "success"
          );
          setIsNewModalOpen(false);
        }
      } else {
        notificationRef.current?.addNotification(
          "No se ha podido crear la tienda.",
          "error"
        );
      }
    } catch (error) {
      console.error("Error creando tienda:", error);
      const message =
        error?.response?.data ||
        "Error creando la tienda. Comprueba la consola.";
      notificationRef.current?.addNotification(String(message), "error");
    } finally {
      setIsCreating(false);
    }
  };

  // ✅ Función para abrir modal de edición
  const handleEditTienda = async (tienda) => {
    try {
      // Obtener datos completos de la tienda
      const response = await api.get(
        `/api/Presupuestos/tiendas/${tienda.codTienda}`
      );

      if (response.status === 200 && response.data) {
        const tiendaCompleta = response.data;
        setTiendaEditando(tiendaCompleta);
        setEditCodigo(tiendaCompleta.codigo || "");
        setEditCadena(tiendaCompleta.cadena || "");
        setEditPais(tiendaCompleta.pais || "");
        setEditCiudad(tiendaCompleta.ciudad || "");
        setEditDireccion(tiendaCompleta.direccion || "");
        setEditFechaCierre(formatDateForInput(tiendaCompleta.fechaCierre));
        setIsEditModalOpen(true);

        const proveedoresSelected = proveedores
          .filter((p) => p.codEmpresa === tiendaCompleta.codEmpresa)
          .map((x) => ({ value: x.codEmpresa, label: x.nombre }));

        setSelectedProveedor(
          proveedoresSelected.length > 0 ? proveedoresSelected[0] : null
        );
      } else {
        notificationRef.current?.addNotification(
          "No se pudo cargar la información de la tienda.",
          "error"
        );
      }
    } catch (error) {
      console.error("Error obteniendo tienda:", error);
      notificationRef.current?.addNotification(
        "Error al cargar la tienda para editar.",
        "error"
      );
    }
  };

  // ✅ Función para cerrar modal de edición
  const closeEditModal = () => {
    setIsEditModalOpen(false);
    setTiendaEditando(null);
  };

  // ✅ Función para actualizar tienda
  const handleUpdateTienda = async () => {
    if (!editCodigo || !editCadena || !editPais || !editCiudad) {
      notificationRef.current?.addNotification(
        "Rellena los campos obligatorios: Código, Cadena, País, Ciudad.",
        "warning"
      );
      return;
    }

    // Validación de código duplicado en edición (excluyendo la tienda actual)
    const codigoExistente = tiendas.find(
      (t) =>
        t.codigo?.toLowerCase() === editCodigo.toLowerCase() &&
        t.codTienda !== tiendaEditando.codTienda
    );
    if (codigoExistente) {
      notificationRef.current?.addNotification(
        `Ya existe otra tienda con el código "${editCodigo}". Por favor, utiliza un código diferente.`,
        "error"
      );
      return;
    }

    const payload = {
      Codigo: editCodigo,
      Cadena: editCadena,
      Pais: editPais,
      Ciudad: editCiudad,
      Direccion: editDireccion || null,
      FechaCierre: editFechaCierre || null,
      CodEmpresa: selectedProveedor ? selectedProveedor.codEmpresa : 0,
    };

    try {
      setIsUpdating(true);
      const response = await api.put(
        `/api/Presupuestos/tiendas/${tiendaEditando.codTienda}`,
        payload
      );

      if (response.status === 200) {
        await fetchTiendasFromApi(); // Recargar lista
        notificationRef.current?.addNotification(
          "Tienda actualizada correctamente.",
          "success"
        );
        setIsEditModalOpen(false);
      } else {
        notificationRef.current?.addNotification(
          "No se ha podido actualizar la tienda.",
          "error"
        );
      }
    } catch (error) {
      console.error("Error actualizando tienda:", error);
      const message = error?.response?.data || "Error actualizando la tienda.";
      notificationRef.current?.addNotification(String(message), "error");
    } finally {
      setIsUpdating(false);
    }
  };

  const handleRowSelect = (selectedRows) => {
    setSelectedTiendas(selectedRows);
  };

  return (
    <div className="tiendas-proveedor">
      <div
        className="dashboard-usuarios__content__table-header"
        style={{ marginBottom: 12 }}
      >
        <InputSearch
          context="tableSearch"
          placeholder="Buscar..."
          onSearch={setSearchTerm}
        />

        <div
          className="dashboard-productos__content__table-header__buttons"
          style={{ marginLeft: 12 }}
        >
          {user?.codTipoEmpresa === 1 && (
            <Button
              label="Cerrar tienda"
              icon={<BsDoorClosed />}
              variant="outlined"
              onClick={openCloseModal}
            />
          )}
          <Button
            label="Nueva tienda"
            icon={<IoAdd />}
            variant="filled"
            onClick={openNewModal}
          />
        </div>
      </div>

      <Table
        data={filtered}
        columns={columns}
        actions={actions} // ✅ Añadir acciones
        selectedItems={selectedTiendas}
        onRowSelect={handleRowSelect}
      />

      <Notification ref={notificationRef} />

      {/* Modal de crear tienda - existing code */}
      <Modal
        title="Crear tienda"
        isOpen={isNewModalOpen}
        onClose={closeNewModal}
        onCancel={closeNewModal}
        onAccept={handleCreateTienda}
        primaryButtonLabel={isCreating ? "Creando..." : "Crear tienda"}
        outlineButtonLabel="Cancelar"
      >
        <div className="dashboard-productos__modal">
          <form
            className="dashboard-productos__modal__content"
            onSubmit={(e) => {
              e.preventDefault();
              handleCreateTienda();
            }}
          >
            <Input
              type="text"
              label="Código"
              value={nuevoCodigo}
              onChange={(e) => setNuevoCodigo(e.target.value)}
              placeholder="Código de la tienda"
            />
            <Input
              type="text"
              label="Cadena"
              value={nuevaCadena}
              onChange={(e) => setNuevaCadena(e.target.value)}
              placeholder="Nombre de la cadena"
            />
            <Input
              type="text"
              label="País"
              value={nuevoPais}
              onChange={(e) => setNuevoPais(e.target.value)}
              placeholder="País"
            />
            <Input
              type="text"
              label="Ciudad"
              value={nuevaCiudad}
              onChange={(e) => setNuevaCiudad(e.target.value)}
              placeholder="Ciudad"
            />
            <Input
              type="text"
              label="Dirección (opcional)"
              value={nuevaDireccion}
              onChange={(e) => setNuevaDireccion(e.target.value)}
              placeholder="Dirección"
            />
            {user?.codTipoEmpresa === 1 ? (
            <Input
              type="date"
              label="Fecha cierre (opcional)"
              value={nuevaFechaCierre}
              onChange={(e) => setNuevaFechaCierre(e.target.value)}
            />
            ) : null}
            {user?.codTipoEmpresa === 1 ? (
              <InputDropdown
                label="Proveedor"
                value={selectedProveedor ? selectedProveedor.codEmpresa : ""}
                onSelect={(e) => {
                  const proveedor = proveedores.find(
                    (p) => p.codEmpresa === e.value
                  );
                  setSelectedProveedor(proveedor || null);
                }}
                options={[
                  ...proveedores.map((proveedor) => ({
                    value: proveedor.codEmpresa,
                    label: proveedor.nombre,
                  })),
                ]}
              />
            ) : null}
          </form>
        </div>
      </Modal>

      {/* ✅ Modal de editar tienda */}
      <Modal
        title="Editar tienda"
        isOpen={isEditModalOpen}
        onClose={closeEditModal}
        onCancel={closeEditModal}
        onAccept={handleUpdateTienda}
        primaryButtonLabel={
          isUpdating ? "Actualizando..." : "Actualizar tienda"
        }
        outlineButtonLabel="Cancelar"
      >
        <div className="dashboard-productos__modal">
          <form
            className="dashboard-productos__modal__content"
            onSubmit={(e) => {
              e.preventDefault();
              handleUpdateTienda();
            }}
          >
            <Input
              type="text"
              label="Código"
              value={editCodigo}
              onChange={(e) => setEditCodigo(e.target.value)}
              placeholder="Código de la tienda"
            />
            <Input
              type="text"
              label="Cadena"
              value={editCadena}
              onChange={(e) => setEditCadena(e.target.value)}
              placeholder="Nombre de la cadena"
            />
            <Input
              type="text"
              label="País"
              value={editPais}
              onChange={(e) => setEditPais(e.target.value)}
              placeholder="País"
            />
            <Input
              type="text"
              label="Ciudad"
              value={editCiudad}
              onChange={(e) => setEditCiudad(e.target.value)}
              placeholder="Ciudad"
            />
            <Input
              type="text"
              label="Dirección (opcional)"
              value={editDireccion}
              onChange={(e) => setEditDireccion(e.target.value)}
              placeholder="Dirección"
            />
            {user?.codTipoEmpresa === 1 ? (
            <Input
              type="date"
              label="Fecha cierre (opcional)"
              value={editFechaCierre}
              onChange={(e) => setEditFechaCierre(e.target.value)}
            />
            ) : null}
            {user?.codTipoEmpresa === 1 ? (
              <InputDropdown
                label="Proveedor"
                value={selectedProveedor ? selectedProveedor : ""}
                onSelect={(e) => {
                  const proveedor = proveedores.find(
                    (p) => p.codEmpresa === e.value
                  );
                  setSelectedProveedor(proveedor || null);
                }}
                options={[
                  ...proveedores.map((proveedor) => ({
                    value: proveedor.codEmpresa,
                    label: proveedor.nombre,
                  })),
                ]}
              />
            ) : null}
          </form>
        </div>
      </Modal>

      {isPopupCloseOpen && (
        <Popup
          type="alert"
          alertType="warning"
          titleMessage="Confirmar cierre"
          alertMessage="¿Estás seguro de que deseas cerrar esta tienda?"
          onConfirm={handleConfirmClose}
          onClose={handleCancelClose}
          confirmLabel="Cerrar"
          cancelLabel="Cancelar"
        />
      )}
    </div>
  );
}
